module.exports = __webpack_public_path__ + "static/w_macarthur-746811d17a527cafdeb00d845c2c3965.png";